/**
 * @module actions/tasks
 */
import axios from 'axios'
import { API_URL, FILE_STORAGE_API } from '../constants'

/**
 * @description Get all tasks from api
 * @return {Promise} Axios promise
 */
export function getTasks (data) {
  let url = FILE_STORAGE_API + '/OtherTask/GetList'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get task by id from api
 * @return {Promise} Axios promise
 */
export function getTask (id) {
  let url = FILE_STORAGE_API + '/OtherTask/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get update / insert task to api
 * @return {Promise} Axios promise
 */
export function createUpdateTask (data) {
  let url = API_URL + '/OtherTask/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function getDeadline (data) {
  let url = API_URL + '/OtherTask/Deadline'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Add orderFile to OtherTaskOccurrence
 * @return {Promise} Axios promise
 */
export function postOccurrenceFile (data) {
  let url = API_URL + '/OtherTask/PostOccurrenceFile'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Upload file
 * @return ..
 */
export function fileUpload (file) {
  let url = FILE_STORAGE_API + '/fileservice/upload?orderID=0'
  let data = new window.FormData()
  data.append(file.name, file)
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Delete file
 * @return ..
 */
export function fileDelete (data) {
  console.log(data)
  let url = FILE_STORAGE_API + '/FileService/Delete'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get all categories from api
 * @return {Promise} Axios promise
 */
export function getCategories () {
  let url = API_URL + '/OtherTask/Categories/0'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get all Othertask occurrence notes from api
 * @return {Promise} Axios promise
 */
export function getOccurrenceNotes (occurrenceId) {
  let url = API_URL + '/OtherTask/GetOccurrenceNotes/' + occurrenceId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get all assigned users to an occurrence
 * @return {Promise} Axios promise
 */
export function getOccurrenceAssigns (occurrenceId) {
  let url = API_URL + '/OtherTask/GetOccurrenceAssigns/' + occurrenceId
  return dispatch => {
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/tasks.js